<ng-template #default>
  <div
    class="actions-container action-box w-full"
    [ngClass]="{
      '!mb-4': filterBubbles.length || brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge,
      '!items-center': ['createProject', 'createStepper'].includes(configObject?.callFrom)
    }"
  >
    <div *ngIf="!projectFlag" class="action-box actions-left !basis-1/12">
      <ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
        <button
          *ngIf="showUploadBtn && (AnyAsset | can: 'upload')"
          (click)="uploadClick.emit()"
          mat-flat-button
          class="button-primary upload-button"
          type="button"
          [attr.data-test-id]="'assets_button-upload'"
        >
          <mat-icon class="material-icons-outlined">cloud_upload</mat-icon>
          <span class="button-label" i18n>Upload</span>
        </button>
      </ng-container>

      <thehubz-asset-bulk-edit
        *ngIf="!hideBulkEdit && bulkEditAccessibility"
        [bulkEditType]="'assets'"
        [showEmptyState]="showEmptyState"
        (toggleSelectAllCheckbox)="selectAll.emit($event.checked)"
        [assetCount]="assetCount"
        (unselectAll)="unselectAll.emit()"
        (editAsset)="editSelectedAsset.emit($event)"
        [buttonText]="bulkEditButtonText"
        tourAnchor="asset-bulk-edit.anchor"
      ></thehubz-asset-bulk-edit>
    </div>
    <div class="text-xl font-medium w-1/3" *ngIf="['createProject', 'createStepper'].includes(configObject?.callFrom)">Asset: {{ assetCount }}</div>
    <div class="actions-right flex w-full justify-between items-center gap-4">
      <div class="flex justify-start md:justify-end xl:justify-end items-center w-full gap-4 mr-2">
        <sp-search-field
          [searchText]="searchText"
          (keyUpInput)="searchTextChanged.emit($event)"
          (clearInput)="clearSearch.emit($event)"
          [placeholder]="searchPlaceholder"
          (toggleMobileSearch)="toggleMobileSearch.emit()"
          (addOnEnter)="addOnEnter.emit($event)"
          tourAnchor="assets-search-field.anchor"
        ></sp-search-field>
        <div *ngIf="!['createProject', 'createStepper'].includes(configObject?.callFrom)">
          <button mat-flat-button type="button" class="button-primary tags-button" (click)="viewAssetTags.emit()" *ngIf="AnyAsset | can: 'tab.tags'" tourAnchor="assets-tags.anchor">
            <mat-icon class="material-icons-outlined">sell</mat-icon>
            <span class="filter-label-wrapper">
              <span class="filter-label" i18n>Tags</span>
            </span>
          </button>
        </div>
        <div class="filter-box relative">
          <button
            mat-flat-button
            type="button"
            class="filter-button button-primary"
            [matMenuTriggerFor]="filterMenu"
            (menuClosed)="restFormField.emit()"
            #menuTrigger
            tourAnchor="assets-filter.anchor.toggle"
          >
            <mat-icon class="material-icons-outlined">filter_alt</mat-icon>
            <span class="filter-label-wrapper">
              <span class="filter-label">Filter </span>
              <span class="filter-count" *ngIf="appliedFilters">({{ appliedFilters }})</span>
            </span>
          </button>
          <mat-menu #filterMenu="matMenu" class="filter-popup-box">
            <ng-template matMenuContent>
              <sp-filter-forms
                [formData]="filterAssetFormData"
                [filterType]="'asset'"
                [className]="brandingKey === CustomClients.SEAT ? 'max-h-[636px]' : brandingKey === CustomClients.VKB ? 'max-h-[580px]' : ''"
                [selectedFilterObject]="selectedFilterObject"
                [roles]="['global.library']"
                (clickApplyFilter)="applyFilters.emit($event)"
                (dropDownChange)="updateFormData.emit($event)"
              >
              </sp-filter-forms>
            </ng-template>
          </mat-menu>
        </div>

        <ng-container *ngIf="screenSizeDetectorService.isLargeScreen">
          <button *ngIf="!projectFlag" mat-icon-button [matMenuTriggerFor]="gridMenu" class="settings-button" tourAnchor="assets-view-settings.anchor.toggle">
            <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
          </button>
          <mat-menu #gridMenu="matMenu">
            <ng-template matMenuContent>
              <sp-table-wheel-setting
                (changeView)="changeAssetView.emit($event)"
                [headerType]="selectedViewType === 'list' ? 'assetList' : 'assetGallery'"
                [menuObjects]="selectedViewType === 'list' ? assetTableMenuObject : assetGalleryMenuObject"
                [selectedViewType]="selectedViewType"
                [selectedViewSection2]="selectedViewSection2"
                (sortBy)="sortToggle.emit($event)"
                [sortByNew]="sortByNew"
                [defaultTableCols]="tableData?.columns"
                [additionalColumns]="tableData?.additionalColumns"
              ></sp-table-wheel-setting>
            </ng-template>
          </mat-menu>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
<ng-template [ngIf]="env.brandingKey === 'vorwerk'" [ngIfElse]="default">
  <div
    class="actions-container action-box flip-on-mobile type-b w-full"
    [ngClass]="{ '!mb-4': filterBubbles.length, '!items-center': ['createProject', 'createStepper'].includes(configObject?.callFrom) }"
  >
    <div class="left-action-box flex w-full justify-between items-center gap-4">
      <div class="flex justify-start items-center w-full gap-4 mr-2">
        @if (screenSizeDetectorService.isLargeScreen) {
          <ng-container *ngTemplateOutlet="vorwerkFilterButton"></ng-container>
        }

        <sp-search-field
          [searchText]="searchText"
          (keyUpInput)="searchTextChanged.emit($event)"
          (clearInput)="clearSearch.emit($event)"
          [placeholder]="searchPlaceholder"
          (toggleMobileSearch)="toggleMobileSearch.emit()"
          (addOnEnter)="addOnEnter.emit($event)"
          tourAnchor="assets-search-field.anchor"
          [mobileSearch]="screenSizeDetectorService.isSmallScreen"
        ></sp-search-field>

        @if (!hideBulkEdit && bulkEditAccessibility && screenSizeDetectorService.isLargeScreen) {
          <thehubz-asset-bulk-edit
            [bulkEditType]="'assets'"
            [showEmptyState]="showEmptyState"
            (toggleSelectAllCheckbox)="selectAll.emit($event.checked)"
            [assetCount]="assetCount"
            (unselectAll)="unselectAll.emit()"
            [buttonText]="'Multi-edit'"
            [showEditButton]="false"
          ></thehubz-asset-bulk-edit>
        }
      </div>
    </div>
    <div class="text-xl font-medium w-1/3" *ngIf="['createProject', 'createStepper'].includes(configObject?.callFrom)">Asset: {{ assetCount }}</div>

    <div *ngIf="!projectFlag" class="action-box right-action-box w-full h-auto flex flex-row justify-start md:justify-end xl:justify-end place-items-center gap-4">
      @if (screenSizeDetectorService.isSmallScreen) {
        <ng-container *ngTemplateOutlet="vorwerkFilterButton"></ng-container>
      }

      <thehubz-asset-bulk-edit
        *ngIf="!hideBulkEdit && bulkEditAccessibility"
        [bulkEditType]="'assets'"
        [showEmptyState]="showEmptyState"
        (toggleSelectAllCheckbox)="selectAll.emit($event.checked)"
        [assetCount]="assetCount"
        (unselectAll)="unselectAll.emit()"
        [buttonText]="'Multi-edit'"
        (editAsset)="editSelectedAsset.emit($event)"
        (updateAssetDraft)="updateAssetDraft.emit($event)"
        (showAssetMismatchDialog)="showAssetMismatchDialog.emit()"
        [showSelectAllCheckbox]="screenSizeDetectorService.isSmallScreen"
        tourAnchor="asset-multi-edit.anchor"
      ></thehubz-asset-bulk-edit>

      @if (screenSizeDetectorService.isLargeScreen) {
        <button
          *ngIf="showUploadBtn && (AnyAsset | can: 'upload')"
          (click)="uploadClick.emit()"
          mat-flat-button
          class="button-primary upload-button"
          type="button"
          [attr.data-test-id]="'assets_button-upload'"
        >
          <mat-icon class="material-icons-outlined m-w-[24px]">add</mat-icon>
          <span class="button-label whitespace-nowrap" i18n>New asset</span>
        </button>
        <div class="hidden" *ngIf="!(AnyAsset | can: 'upload')">Upload button requires "upload"</div>
      }

      <div *ngIf="!projectFlag && assetCount > 0" class="guided-tour-target clickable hide-on-mobile">
        <button mat-icon-button [matMenuTriggerFor]="gridMenu" tourAnchor="assets-view-settings.anchor.toggle" class="settings-button">
          <mat-icon class="material-icons-outlined" matTooltip="Table setting">settings</mat-icon>
        </button>
      </div>
      <mat-menu #gridMenu="matMenu">
        <ng-template matMenuContent>
          <sp-table-wheel-setting
            [headerType]="selectedViewType === 'list' ? 'assetList' : 'assetGallery'"
            [menuObjects]="selectedViewType === 'list' ? assetTableMenuObject : assetGalleryMenuObject"
            [selectedViewType]="selectedViewType"
            [selectedViewSection2]="selectedViewSection2"
            [sortByNew]="sortByNew"
            [gridSettingsKeySuffix]="gridSettingsKeySuffix"
            (changeView)="changeAssetView.emit($event)"
            (sortBy)="sortToggle.emit($event)"
            [defaultTableCols]="tableData?.columns"
            [additionalColumns]="tableData?.additionalColumns"
          ></sp-table-wheel-setting>
        </ng-template>
      </mat-menu>
    </div>
  </div>
</ng-template>

<ng-template #vorwerkFilterButton>
  <div class="filter-box relative">
    <button
      mat-flat-button
      type="button"
      class="filter-button button-primary guided-tour-target"
      (click)="toggleSidebar.emit()"
      aria-controls="assets-sidebar"
      [attr.aria-expanded]="assetViewTypeService.getGridSettings('showGridViewSidebar', gridSettingsKeySuffix)"
      tourAnchor="assets-filter.anchor"
    >
      <mat-icon class="material-icons-outlined">filter_alt</mat-icon>
      <span class="filter-label-wrapper">
        @if (screenSizeDetectorService.isLargeScreen) {
          <span *ngIf="!assetViewTypeService.getGridSettings('showGridViewSidebar', gridSettingsKeySuffix)" class="filter-label font-bold" i18n>Show filters</span>
          <span *ngIf="assetViewTypeService.getGridSettings('showGridViewSidebar', gridSettingsKeySuffix)" class="filter-label font-bold" i18n>Hide filters</span>
        } @else {
          <span class="filter-label font-bold" i18n>Filters</span>
        }
        <span class="filter-count font-bold" *ngIf="appliedFilters">({{ appliedFilters }})</span>
      </span>
    </button>
    <mat-menu #filterMenu="matMenu" class="filter-popup-box">
      <ng-template matMenuContent>
        <sp-filter-forms
          [formData]="filterAssetFormData"
          [filterType]="'asset'"
          [selectedFilterObject]="selectedFilterObject"
          [roles]="['global.library']"
          (clickApplyFilter)="applyFilters.emit($event)"
          (dropDownChange)="updateFormData.emit($event.formControlName)"
        >
        </sp-filter-forms>
      </ng-template>
    </mat-menu>
  </div>
</ng-template>
